import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/base/ScrollToTop";
import SchemaOrg from "@/components/base/SchemaOrg";
import HeroSection from "./components/HeroSection";
import FeaturedSection from "./components/FeaturedSection";
import CategorySection from "./components/CategorySection";
import LatestSection from "./components/LatestSection";
import FAQSection from "./components/FAQSection";

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SchemaOrg
        type="WebPage"
        data={{
          name: "八戒影院 - 高清免费在线观看",
          description: "八戒影院提供海量高清免费影视在线观看，无需缓冲流畅播放。涵盖电视剧全集、电影大全及最新影视资源，每日同步更新。",
          url: "https://smwneuh.cn/",
          isPartOf: {
            "@type": "WebSite",
            name: "八戒影院",
            url: "https://smwneuh.cn/",
          },
        }}
      />
      <SchemaOrg
        type="FAQPage"
        data={{
          mainEntity: [
            { "@type": "Question", name: "八戒影院的影片资源是否免费？", acceptedAnswer: { "@type": "Answer", text: "是的，八戒影院所有影片资源均免费提供在线观看，无需注册、无需付费，打开网站即可畅享高清影视内容。" } },
            { "@type": "Question", name: "观看影片需要安装播放器吗？", acceptedAnswer: { "@type": "Answer", text: "不需要。八戒影院采用最新的HTML5播放技术，支持主流浏览器直接播放，无需安装任何插件或播放器，打开即看。" } },
            { "@type": "Question", name: "影片更新频率是怎样的？", acceptedAnswer: { "@type": "Answer", text: "我们每天都会同步更新最新上映的电影和热播电视剧，确保您能够在第一时间观看到最新的影视内容。" } },
            { "@type": "Question", name: "八戒影院的画质如何？", acceptedAnswer: { "@type": "Answer", text: "我们提供高清甚至超清画质的影片资源，大部分内容支持1080P高清播放。同时采用先进的视频编码技术，确保在不缓冲的情况下流畅播放。" } },
            { "@type": "Question", name: "为什么叫八戒影院？", acceptedAnswer: { "@type": "Answer", text: "八戒是中国古典名著《西游记》中的经典角色，寓意接地气、亲民、有趣。我们希望八戒影院能像八戒一样，成为大家日常娱乐生活中不可或缺的一部分。" } },
            { "@type": "Question", name: "支持手机和平板观看吗？", acceptedAnswer: { "@type": "Answer", text: "完全支持！八戒影院采用响应式设计，完美适配手机、平板和电脑等各种设备。" } },
          ],
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedSection />
        <CategorySection />
        <LatestSection />
        <FAQSection />
        <section className="px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-[1280px] mx-auto text-center">
            <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950 mb-3">
              立即开始免费观影
            </h2>
            <p className="text-sm text-foreground-500 mb-6 max-w-xl mx-auto">
              加入八戒影院，畅享海量高清影视资源，每日更新，完全免费
            </p>
            <a
              href="/category/all"
              className="inline-block px-8 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              开始探索
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}